import React from "react";

import RAGIndicatorNew from "components/visuals/RAGIndicatorNew";

import { useAppSelector } from "store";
import { selectLocationAlignment } from "modules/customer/tools/location/overview/overviewSlice";

const LocationAlignment: React.FC = () => {
    const locationAlignment = useAppSelector(selectLocationAlignment);
    return (
        <RAGIndicatorNew ragIndicator={locationAlignment} />
    );
};

export default LocationAlignment;
